var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('menuLateral',{ref:"menuLateral",staticClass:"menu-lateral"}),_c('navbar',{on:{"click":_vm.lateralMobile}}),_c('div',{staticClass:"position-relative app-wrapper px-4 pt-4"},[_c('child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }